import { useQuery } from '@apollo/client';
import { SkeletonLoading } from '@nile/components';
import {
  AccountClient,
  getNonAuthToken,
  NonAuthAccountClient
} from '@nile/graphql';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { getTransformedChartData } from '@nile/reports/src/modules/charts/utils/chart-transformation';
import SharedReportSheet from '@nile/reports/src/modules/reports/components/subpages/SharedReportSheet';
import { GET_SHARED_REPORT } from '@nile/reports/src/modules/reports/graphql';
import { cloneDeep } from 'lodash';
import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { RETAINER_REPORT } from '@nile/reports/src/modules/home/constants';
import { SharedReportWrapper } from './styles';
import PrintReport from '../../subpages/PrintReport';

const SharedReport = (props) => {
  const { match, sharedReportId, isExported = false } = props;
  const token = getNonAuthToken();

  const externalsharedReportId = token
    ? match.params.id?.split(/[?&]/)?.[0]
    : match.params.id;

  const context = useContext(TicketContext);

  const [updatedData, setUpdatedData] = useState(null);

  const { loading } = useQuery(GET_SHARED_REPORT, {
    client: token ? NonAuthAccountClient : AccountClient,
    fetchPolicy: 'network-only',
    variables: {
      sharedReportId:
        sharedReportId || externalsharedReportId || match.params.id
    },
    skip: !(sharedReportId || externalsharedReportId || match.params.id),
    onCompleted({ getSharedReport }) {
      const updatedNewData = cloneDeep(getSharedReport);

      if (updatedNewData.reportName === 'Retainer Report') {
        if (!isExported && sharedReportId) {
          // context shouldnt update for external user
          context.updateTab({
            module: 'SHARED_REPORT',
            data: {
              title: updatedNewData?.reportName || 'Shared report',
              reportId: updatedNewData?.id
            }
          });
        }
        setUpdatedData(updatedNewData);
        return;
      }

      const updatedLayout = updatedNewData.layout.layout.map((item) => {
        return {
          ...item,
          chartOptions: getTransformedChartData(
            updatedNewData.data[item.chart.chartId],
            item.chart.metrics?.length,
            item.chart.groupBy?.length,
            item.chart.defaultChartType
          ),
          chartRawData: updatedNewData.data[item.chart.chartId]
        };
      });
      updatedNewData.layout.layout = updatedLayout;
      if (!isExported) {
        // context shouldnt update for external user
        props.sharedReportId &&
          context.updateTab({
            module: 'SHARED_REPORT',
            data: {
              title: updatedNewData?.reportName || 'Shared report',
              reportId: updatedNewData?.id
            }
          });
      }
      setUpdatedData(updatedNewData);
    }
  });

  if (loading || !updatedData) {
    return (
      <SkeletonLoading
        hideStepNav
        hideTable
        showCardView
        hideSecondaryHeader
        showPlainCardView={false}
        showBox={false}
      />
    );
  }

  return (
    <SharedReportWrapper loading={loading}>
      {!!sharedReportId ? (
        <PrintReport data={updatedData} isExport={!!sharedReportId} />
      ) : (
        <SharedReportSheet data={updatedData} isExport={!!sharedReportId} />
      )}
    </SharedReportWrapper>
  );
};

export default withRouter(SharedReport);
